/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MeProfileResponse } from "./MeProfileResponse";

export type MeProfileResponseApiRespoonse = {
  data?: MeProfileResponse;
  status?: MeProfileResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MeProfileResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
